import Main from './pages/Main';

const routes = [{ path: '/', component: Main }];

export default routes;
